import decode from 'jwt-decode'

import storage from 'utils/storage'

export const checkAuth = () => {
  const token = storage.getToken()
  if (!token) { return false }
  const decoded = decode(token)
  const exp = new Date(decoded.exp)
  if (new Date().getTime() > exp.getTime()) { return false }
  return true
}
